"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MichiganRules = void 0;
const browser_1 = require("encamp-prisma/generated/browser");
const stateWasteCodes_1 = require("../stateWasteCodes");
const _FEDERAL_1 = require("./_FEDERAL");
const _stateRules_1 = require("./_stateRules");
/**
 * Michigan (EGLE) uses the federal thresholds. Its one
 * departure is which waste counts acute: Michigan's "severely toxic
 * hazardous waste" counts toward the acute limits.
 */
/**
 * Michigan's "severely toxic hazardous waste", R 299.9219 Table 202, in
 * canonical bare form (`001S`, not `MI-001S`). Mich. Admin. Code R 299.9304,
 * 299.9305(1), 299.9212, 299.9219.
 */
const MI_ACUTE_WASTE_CODES = [
    "001S",
    "002S",
    "003S",
    "004S",
    "005S",
    "006S",
    "007S",
];
/** Michigan (EGLE) accumulation limits: the federal thresholds, with its own acute codes. */
class MichiganRules extends _stateRules_1.StateRules {
    constructor() {
        super(...arguments);
        this.stateStatusDomain = [];
        this.adoptsEpisodicEvents = true;
    }
    facilityThresholds(facility) {
        return _FEDERAL_1.Federal.onSiteThresholds(facility);
    }
    areaThresholds(situation) {
        return _FEDERAL_1.Federal.areaThresholds(situation);
    }
    governingProgram(container) {
        return _FEDERAL_1.Federal.governingProgram(container);
    }
    accumulationCategory(container) {
        if (container.classification === browser_1.WasteClassification.RCRA_ACUTELY_HAZARDOUS) {
            return { value: "ACUTE" };
        }
        const hasAcuteStateWasteCode = (0, stateWasteCodes_1.hasSomeOfGivenStateWasteCodes)(container, MI_ACUTE_WASTE_CODES);
        if (hasAcuteStateWasteCode.value === undefined) {
            return { missing: hasAcuteStateWasteCode.missing };
        }
        if (hasAcuteStateWasteCode.value) {
            return { value: "ACUTE" };
        }
        // STATE_REGULATED is non-acute pending the waste team's per-state decision.
        if (container.classification === browser_1.WasteClassification.STATE_REGULATED) {
            return { value: "NON_ACUTE" };
        }
        return _FEDERAL_1.Federal.category(container);
    }
    /** The federal container thresholds, with move windows following this state's acute codes. */
    containerThresholds(situation) {
        return _FEDERAL_1.Federal.containerThresholds(this, situation);
    }
}
exports.MichiganRules = MichiganRules;
//# sourceMappingURL=MI.js.map